import React from "react";
import { useNavigate } from "react-router-dom";
import { atom, useRecoilState } from "recoil";
import styled from "styled-components";
import {
  PointTabColumn,
  PointTabContainer,
  PointTabText,
  STabBar,
} from "../../Benefit/Point/PointTab";
import { isNewChat } from "../../../../pages/Party/ChatInfo";
import Flex from "../../../DefaultStyles/Flex";
import ToggleBtn from "../../../Button/ToggleBtn";
import { ChatType } from "./ChatSearch/RecentChat/RecentChatHeader";

export const chatTabState = atom<number>({
  key: "chatTabState",
  default: 0,
});

interface ChatTabProps {
  isFirebaseChat: boolean;
  toggleButtonEvent: () => void;
}

export default function ChatTab({
  isFirebaseChat,
  toggleButtonEvent,
}: ChatTabProps) {
  const navigate = useNavigate();
  const [tab, setTab] = useRecoilState(chatTabState);

  return (
    <PointTabContainer style={{ justifyContent: "space-between" }}>
      <Flex gapSize={20}>
        <PointTabColumn
          onClick={() => {
            navigate("/party/chat");
            setTab(0);
          }}
        >
          <PointTabText isActive={Boolean(tab === 0)}>
            최근 전체 대화
          </PointTabText>

          <PointTabBar tab={tab} />
        </PointTabColumn>

        <PointTabColumn
          onClick={() => {
            navigate("/party/chat");
            setTab(1);
          }}
        >
          <PointTabText isActive={Boolean(tab === 1)}>채팅 검색</PointTabText>
        </PointTabColumn>

        <PointTabColumn
          onClick={() => {
            navigate("/party/chat");
            setTab(2);
          }}
        >
          <PointTabText isActive={Boolean(tab === 2)}>
            신고/처리 완료
          </PointTabText>
        </PointTabColumn>
      </Flex>

      {isNewChat && tab === 0 ? (
        <Flex gapSize={8}>
          <ToggleBtn check={!isFirebaseChat} checkEvent={toggleButtonEvent} />

          <ChatType isFirebase={isFirebaseChat}>
            {isFirebaseChat ? "firebase" : "새 채팅"}
          </ChatType>
        </Flex>
      ) : (
        <></>
      )}
    </PointTabContainer>
  );
}

const PointTabBar = styled.div<STabBar>`
  position: absolute;
  width: ${({ tab }) => (tab === 0 ? 102 : tab === 1 ? 67 : 104)}px;
  height: 3px;
  background-color: ${({ theme }) => theme.color.gray900};
  bottom: -8px;
  left: ${({ tab }) => (tab === 0 ? 0 : tab === 1 ? 122 : 87 + 122)}px;

  transition: left 0.2s ease;
`;
